import { render, staticRenderFns } from "./AssetsOnHire.vue?vue&type=template&id=4581995a&scoped=true"
import script from "./AssetsOnHire.vue?vue&type=script&lang=js"
export * from "./AssetsOnHire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4581995a",
  null
  
)

export default component.exports